const Ls = {
  HOME: "/",
  LOGIN: { PATH: "login", NAME: "Login" },
  USER: { PATH: "/user", NAME: "User", SHOW: "security.title" },
  // Maps to Security Settings
  ACCOUNT_DELETE: { PATH: "/account-delete", NAME: "account-delete" },
  // Maps to Security Settings
  PRIVACY: { PATH: "/account-privacy", NAME: "account-privacy" },
  // Maps to Security Settings
  TERMS_SERVICE: { PATH: "/account-terms-serivces", NAME: "account-terms-serivces" },
  // Maps to Security Settings
  ADMIN: { PATH: "admin", NAME: "Admin" },
  // Business Modules
  INVENTORY: { PATH: "inventory", NAME: "Inventory" },
  ABOUT: { PATH: "/about", NAME: "about" },
  DEMO: { PATH: "/demo", NAME: "demo" },
  BLOG: { PATH: "/blog", NAME: "Blog" },
  REPORT: { PATH: "/report", NAME: "Report", SHOW: "report.title" },
  MENU: { PATH: "/menu", NAME: "Menu", SHOW: "menu.editorTitle" },
  MENU_ORDER: { PATH: "/menu_order/:qr", NAME: "MenuOrder", SHOW: "order.ordering" },
  ALL_ORDER: { PATH: "/all_order", NAME: "AllOrder", SHOW: "order.manage" },
  TABLE_POST: { PATH: "/table_post", NAME: "TablePost", SHOW: "tables.title" },
  UPLOAD_R2: { PATH: "/upload_r2", NAME: "upload_r2", SHOW: "upload_r2.title" },
  PERSONNEL: { PATH: "/personnel", NAME: "Personnel", SHOW: "personnel.title" },
  // Added personnel
  ECPAY: { PATH: "/ecpay", NAME: "Ecpay", SHOW: "ecpay.title" },
  PAYMENT: { PATH: "/payment", NAME: "payment" },
  PAYMENT_SUCCESS: { PATH: "/payment-success", NAME: "payment-success" },
  INVENTORY2: { PATH: "/inventory2", NAME: "Inventory2" },
  // S1 Module
  S1: {
    USER: { PATH: "s1/user", NAME: "S1User" },
    ADMIN: { PATH: "s1/admin", NAME: "S1Admin" },
    ADMIN2: { PATH: "s1/admin2", NAME: "S1Admin2" }
  },
  BOOKING: {
    CONFIG: { PATH: "/booking/config", NAME: "config", SHOW: "booking.config.title" },
    RESERVATION: { PATH: "/booking/reservation", NAME: "reservation", SHOW: "booking.reservation.title" }
  },
  // Post Details
  POST_DETAIL: { PATH: "/posts/:id", NAME: "PostDetail", SHOW: "" },
  // Order Management
  CHECKOUT: {
    PATH: "/order_management/:qr",
    NAME: "OrderManagementPage",
    SHOW: "orderHistory.title"
  }
}, Is = {
  ACCOUNT: {
    REGISTER: "/api/go-bff-service/public/register/merchant",
    LOGIN: "/api/server/auth/login",
    LOGIN2: "/api/go-bff-service/public/login/merchant",
    CHANGE_PASS: "/api/auth/change_pass"
  },
  USER_INFO: {
    ME: "/api/user_info/me",
    ME2: "/api/user_info/me2",
    STATUS: (e) => `/api/user_info/${e}/status`
  },
  CLIENT: {
    ME: "/api/client/me"
  },
  BLOG: {
    POSTS: "/api/blog/posts",
    GET_POSTS: "/api/go-bff-service/public/blog/public/posts",
    COMMENTS: (e) => `/api/blog/comments/${e}/comments`,
    DETAIL: (e) => `/api/blog/posts/${e}`
  },
  MENU: {
    GET_MENU_BY_QR: (e) => `/api/menu/public/table/order/${e}`,
    GET_ORDERS_SESSION_BY_QR: (e) => `/api/menu/public/table/order/get/${e}`,
    GET_ORDERS_BY_QR: (e) => `/api/menu/table/order/get/${e}`,
    ORDER_SUBMIT: "/api/menu/table/order",
    BY_MERCHANT: (e) => `/api/menu/menu/${e}`,
    BASE: "/api/menu/menu",
    TABLE: "/api/menu/table",
    TIMEZONE: "/api/menu/tz",
    TIMEZONE_GET: "/api/menu/public/tz/:id",
    MERCHANT_INFO_GET: "/api/menu/public/merchant/info/:merchant_id",
    CATEGORY: "/api/menu/category",
    CATEGORY_ASSIGN: "/api/menu/categories/:id",
    CATEGORY_ITEMS: (e) => `/api/menu/category/${e}/items`
  },
  MERCHANT: {
    TIMEZONE: "/api/merchant/timezone"
  },
  BFF: {
    TABLES_WITH_QR: "/api/go-bff-service/tables-with-qr",
    R2_PRESIGNED_URL: "/api/go-bff-service/r2/get_presigned_url",
    PAYMENT_BATCH_CHECKOUT: "/api/go-bff-service/public/payment/batch-checkout",
    PAYMENT_CHECK_DUPLICATES: "/api/go-bff-service/public/payment/check-duplicates",
    CREATE_INVOICE: "/api/go-bff-service/invoice/create",
    VOID_PAYMENT: "/api/go-bff-service/payment/void"
  },
  MESSAGE: {
    BASE: "/api/message",
    MesPathSaveToken: "/save_token",
    MesPathGetTokens: "/get_tokens",
    MesPathDisableTokens: "/disable_tokens"
  },
  REPORT: {
    WEEKLY_REPORT: "/api/menu/reports/weekly"
  },
  ORDERS: {
    GET_ALL_ORDERS: "/api/menu/orders/order",
    GET_ALL_ORDER_WITH_PAGE: "/api/menu/orders/order_page",
    ACTIVE: "/api/v1/orders/active",
    ITEMS: "/api/menu/table/order/item/status/update",
    CHECKOUT: "/api/menu/table/order/checkout",
    STATUS_UPDATE: "/api/menu/orders/status/update"
  },
  BOOKING: {
    CONFIG: "/api/booking/merchants/configs",
    IMAGES: "/api/booking/merchants/images",
    IMAGE_COMPLETE: (e) => `/api/booking/merchants/images/${e}/complete`,
    TIME_CONFIG: "/api/booking/merchants/booking_time_config",
    HOLIDAYS: "/api/booking/merchants/holidays",
    RESERVATIONS: "/api/booking/merchants/reservations",
    PUBLIC_MATRIX: (e) => `/api/booking/public/merchants/${e}/matrix`,
    PUBLIC_ORDERS: (e) => `/api/booking/public/merchants/${e}/orders`,
    PUBLIC_IMAGES: "/api/booking/public/merchants/:id/images"
  },
  ECPAY: {
    MERCHANT_PAYMENT_INFO: "/api/ecpay-helper/payment/merchant",
    MERCHANT_PAYMENT_INFO_PAGINATED: "/api/ecpay-helper/payment/merchant/paginated",
    QUERY_COMPANY_NAME: (e) => `/api/ecpay-helper/query/company/${e}`,
    QUERY_COMPANY_NAME_PUBLIC: (e) => `/api/ecpay-helper/public/query/company/${e}`
  }
};
var ct = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ut(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Nt = { exports: {} };
(function(e, t) {
  (function(o, n) {
    e.exports = n();
  })(ct, function() {
    var o = 1e3, n = 6e4, r = 36e5, i = "millisecond", l = "second", h = "minute", w = "hour", O = "day", Y = "week", z = "month", T = "quarter", S = "year", y = "date", f = "Invalid Date", C = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, _ = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, H = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(p) {
      var u = ["th", "st", "nd", "rd"], a = p % 100;
      return "[" + p + (u[(a - 20) % 10] || u[a] || u[0]) + "]";
    } }, M = function(p, u, a) {
      var m = String(p);
      return !m || m.length >= u ? p : "" + Array(u + 1 - m.length).join(a) + p;
    }, q = { s: M, z: function(p) {
      var u = -p.utcOffset(), a = Math.abs(u), m = Math.floor(a / 60), c = a % 60;
      return (u <= 0 ? "+" : "-") + M(m, 2, "0") + ":" + M(c, 2, "0");
    }, m: function p(u, a) {
      if (u.date() < a.date()) return -p(a, u);
      var m = 12 * (a.year() - u.year()) + (a.month() - u.month()), c = u.clone().add(m, z), g = a - c < 0, b = u.clone().add(m + (g ? -1 : 1), z);
      return +(-(m + (a - c) / (g ? c - b : b - c)) || 0);
    }, a: function(p) {
      return p < 0 ? Math.ceil(p) || 0 : Math.floor(p);
    }, p: function(p) {
      return { M: z, y: S, w: Y, d: O, D: y, h: w, m: h, s: l, ms: i, Q: T }[p] || String(p || "").toLowerCase().replace(/s$/, "");
    }, u: function(p) {
      return p === void 0;
    } }, D = "en", F = {};
    F[D] = H;
    var K = "$isDayjsObject", re = function(p) {
      return p instanceof Ne || !(!p || !p[K]);
    }, X = function p(u, a, m) {
      var c;
      if (!u) return D;
      if (typeof u == "string") {
        var g = u.toLowerCase();
        F[g] && (c = g), a && (F[g] = a, c = g);
        var b = u.split("-");
        if (!c && b.length > 1) return p(b[0]);
      } else {
        var A = u.name;
        F[A] = u, c = A;
      }
      return !m && c && (D = c), c || !m && D;
    }, P = function(p, u) {
      if (re(p)) return p.clone();
      var a = typeof u == "object" ? u : {};
      return a.date = p, a.args = arguments, new Ne(a);
    }, E = q;
    E.l = X, E.i = re, E.w = function(p, u) {
      return P(p, { locale: u.$L, utc: u.$u, x: u.$x, $offset: u.$offset });
    };
    var Ne = function() {
      function p(a) {
        this.$L = X(a.locale, null, !0), this.parse(a), this.$x = this.$x || a.x || {}, this[K] = !0;
      }
      var u = p.prototype;
      return u.parse = function(a) {
        this.$d = function(m) {
          var c = m.date, g = m.utc;
          if (c === null) return /* @__PURE__ */ new Date(NaN);
          if (E.u(c)) return /* @__PURE__ */ new Date();
          if (c instanceof Date) return new Date(c);
          if (typeof c == "string" && !/Z$/i.test(c)) {
            var b = c.match(C);
            if (b) {
              var A = b[2] - 1 || 0, B = (b[7] || "0").substring(0, 3);
              return g ? new Date(Date.UTC(b[1], A, b[3] || 1, b[4] || 0, b[5] || 0, b[6] || 0, B)) : new Date(b[1], A, b[3] || 1, b[4] || 0, b[5] || 0, b[6] || 0, B);
            }
          }
          return new Date(c);
        }(a), this.init();
      }, u.init = function() {
        var a = this.$d;
        this.$y = a.getFullYear(), this.$M = a.getMonth(), this.$D = a.getDate(), this.$W = a.getDay(), this.$H = a.getHours(), this.$m = a.getMinutes(), this.$s = a.getSeconds(), this.$ms = a.getMilliseconds();
      }, u.$utils = function() {
        return E;
      }, u.isValid = function() {
        return this.$d.toString() !== f;
      }, u.isSame = function(a, m) {
        var c = P(a);
        return this.startOf(m) <= c && c <= this.endOf(m);
      }, u.isAfter = function(a, m) {
        return P(a) < this.startOf(m);
      }, u.isBefore = function(a, m) {
        return this.endOf(m) < P(a);
      }, u.$g = function(a, m, c) {
        return E.u(a) ? this[m] : this.set(c, a);
      }, u.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, u.valueOf = function() {
        return this.$d.getTime();
      }, u.startOf = function(a, m) {
        var c = this, g = !!E.u(m) || m, b = E.p(a), A = function(fe, G) {
          var le = E.w(c.$u ? Date.UTC(c.$y, G, fe) : new Date(c.$y, G, fe), c);
          return g ? le : le.endOf(O);
        }, B = function(fe, G) {
          return E.w(c.toDate()[fe].apply(c.toDate("s"), (g ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(G)), c);
        }, N = this.$W, j = this.$M, te = this.$D, ve = "set" + (this.$u ? "UTC" : "");
        switch (b) {
          case S:
            return g ? A(1, 0) : A(31, 11);
          case z:
            return g ? A(1, j) : A(0, j + 1);
          case Y:
            var we = this.$locale().weekStart || 0, Se = (N < we ? N + 7 : N) - we;
            return A(g ? te - Se : te + (6 - Se), j);
          case O:
          case y:
            return B(ve + "Hours", 0);
          case w:
            return B(ve + "Minutes", 1);
          case h:
            return B(ve + "Seconds", 2);
          case l:
            return B(ve + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, u.endOf = function(a) {
        return this.startOf(a, !1);
      }, u.$set = function(a, m) {
        var c, g = E.p(a), b = "set" + (this.$u ? "UTC" : ""), A = (c = {}, c[O] = b + "Date", c[y] = b + "Date", c[z] = b + "Month", c[S] = b + "FullYear", c[w] = b + "Hours", c[h] = b + "Minutes", c[l] = b + "Seconds", c[i] = b + "Milliseconds", c)[g], B = g === O ? this.$D + (m - this.$W) : m;
        if (g === z || g === S) {
          var N = this.clone().set(y, 1);
          N.$d[A](B), N.init(), this.$d = N.set(y, Math.min(this.$D, N.daysInMonth())).$d;
        } else A && this.$d[A](B);
        return this.init(), this;
      }, u.set = function(a, m) {
        return this.clone().$set(a, m);
      }, u.get = function(a) {
        return this[E.p(a)]();
      }, u.add = function(a, m) {
        var c, g = this;
        a = Number(a);
        var b = E.p(m), A = function(j) {
          var te = P(g);
          return E.w(te.date(te.date() + Math.round(j * a)), g);
        };
        if (b === z) return this.set(z, this.$M + a);
        if (b === S) return this.set(S, this.$y + a);
        if (b === O) return A(1);
        if (b === Y) return A(7);
        var B = (c = {}, c[h] = n, c[w] = r, c[l] = o, c)[b] || 1, N = this.$d.getTime() + a * B;
        return E.w(N, this);
      }, u.subtract = function(a, m) {
        return this.add(-1 * a, m);
      }, u.format = function(a) {
        var m = this, c = this.$locale();
        if (!this.isValid()) return c.invalidDate || f;
        var g = a || "YYYY-MM-DDTHH:mm:ssZ", b = E.z(this), A = this.$H, B = this.$m, N = this.$M, j = c.weekdays, te = c.months, ve = c.meridiem, we = function(G, le, Pe, Re) {
          return G && (G[le] || G(m, g)) || Pe[le].slice(0, Re);
        }, Se = function(G) {
          return E.s(A % 12 || 12, G, "0");
        }, fe = ve || function(G, le, Pe) {
          var Re = G < 12 ? "AM" : "PM";
          return Pe ? Re.toLowerCase() : Re;
        };
        return g.replace(_, function(G, le) {
          return le || function(Pe) {
            switch (Pe) {
              case "YY":
                return String(m.$y).slice(-2);
              case "YYYY":
                return E.s(m.$y, 4, "0");
              case "M":
                return N + 1;
              case "MM":
                return E.s(N + 1, 2, "0");
              case "MMM":
                return we(c.monthsShort, N, te, 3);
              case "MMMM":
                return we(te, N);
              case "D":
                return m.$D;
              case "DD":
                return E.s(m.$D, 2, "0");
              case "d":
                return String(m.$W);
              case "dd":
                return we(c.weekdaysMin, m.$W, j, 2);
              case "ddd":
                return we(c.weekdaysShort, m.$W, j, 3);
              case "dddd":
                return j[m.$W];
              case "H":
                return String(A);
              case "HH":
                return E.s(A, 2, "0");
              case "h":
                return Se(1);
              case "hh":
                return Se(2);
              case "a":
                return fe(A, B, !0);
              case "A":
                return fe(A, B, !1);
              case "m":
                return String(B);
              case "mm":
                return E.s(B, 2, "0");
              case "s":
                return String(m.$s);
              case "ss":
                return E.s(m.$s, 2, "0");
              case "SSS":
                return E.s(m.$ms, 3, "0");
              case "Z":
                return b;
            }
            return null;
          }(G) || b.replace(":", "");
        });
      }, u.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, u.diff = function(a, m, c) {
        var g, b = this, A = E.p(m), B = P(a), N = (B.utcOffset() - this.utcOffset()) * n, j = this - B, te = function() {
          return E.m(b, B);
        };
        switch (A) {
          case S:
            g = te() / 12;
            break;
          case z:
            g = te();
            break;
          case T:
            g = te() / 3;
            break;
          case Y:
            g = (j - N) / 6048e5;
            break;
          case O:
            g = (j - N) / 864e5;
            break;
          case w:
            g = j / r;
            break;
          case h:
            g = j / n;
            break;
          case l:
            g = j / o;
            break;
          default:
            g = j;
        }
        return c ? g : E.a(g);
      }, u.daysInMonth = function() {
        return this.endOf(z).$D;
      }, u.$locale = function() {
        return F[this.$L];
      }, u.locale = function(a, m) {
        if (!a) return this.$L;
        var c = this.clone(), g = X(a, m, !0);
        return g && (c.$L = g), c;
      }, u.clone = function() {
        return E.w(this.$d, this);
      }, u.toDate = function() {
        return new Date(this.valueOf());
      }, u.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, u.toISOString = function() {
        return this.$d.toISOString();
      }, u.toString = function() {
        return this.$d.toUTCString();
      }, p;
    }(), $t = Ne.prototype;
    return P.prototype = $t, [["$ms", i], ["$s", l], ["$m", h], ["$H", w], ["$W", O], ["$M", z], ["$y", S], ["$D", y]].forEach(function(p) {
      $t[p[1]] = function(u) {
        return this.$g(u, p[0], p[1]);
      };
    }), P.extend = function(p, u) {
      return p.$i || (p(u, Ne, P), p.$i = !0), P;
    }, P.locale = X, P.isDayjs = re, P.unix = function(p) {
      return P(1e3 * p);
    }, P.en = F[D], P.Ls = F, P.p = {}, P;
  });
})(Nt);
var Ho = Nt.exports;
const Ke = /* @__PURE__ */ ut(Ho);
var Rt = { exports: {} };
(function(e, t) {
  (function(o, n) {
    e.exports = n();
  })(ct, function() {
    var o = "minute", n = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
    return function(i, l, h) {
      var w = l.prototype;
      h.utc = function(f) {
        var C = { date: f, utc: !0, args: arguments };
        return new l(C);
      }, w.utc = function(f) {
        var C = h(this.toDate(), { locale: this.$L, utc: !0 });
        return f ? C.add(this.utcOffset(), o) : C;
      }, w.local = function() {
        return h(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var O = w.parse;
      w.parse = function(f) {
        f.utc && (this.$u = !0), this.$utils().u(f.$offset) || (this.$offset = f.$offset), O.call(this, f);
      };
      var Y = w.init;
      w.init = function() {
        if (this.$u) {
          var f = this.$d;
          this.$y = f.getUTCFullYear(), this.$M = f.getUTCMonth(), this.$D = f.getUTCDate(), this.$W = f.getUTCDay(), this.$H = f.getUTCHours(), this.$m = f.getUTCMinutes(), this.$s = f.getUTCSeconds(), this.$ms = f.getUTCMilliseconds();
        } else Y.call(this);
      };
      var z = w.utcOffset;
      w.utcOffset = function(f, C) {
        var _ = this.$utils().u;
        if (_(f)) return this.$u ? 0 : _(this.$offset) ? z.call(this) : this.$offset;
        if (typeof f == "string" && (f = function(D) {
          D === void 0 && (D = "");
          var F = D.match(n);
          if (!F) return null;
          var K = ("" + F[0]).match(r) || ["-", 0, 0], re = K[0], X = 60 * +K[1] + +K[2];
          return X === 0 ? 0 : re === "+" ? X : -X;
        }(f), f === null)) return this;
        var H = Math.abs(f) <= 16 ? 60 * f : f;
        if (H === 0) return this.utc(C);
        var M = this.clone();
        if (C) return M.$offset = H, M.$u = !1, M;
        var q = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        return (M = this.local().add(H + q, o)).$offset = H, M.$x.$localOffset = q, M;
      };
      var T = w.format;
      w.format = function(f) {
        var C = f || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return T.call(this, C);
      }, w.valueOf = function() {
        var f = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * f;
      }, w.isUTC = function() {
        return !!this.$u;
      }, w.toISOString = function() {
        return this.toDate().toISOString();
      }, w.toString = function() {
        return this.toDate().toUTCString();
      };
      var S = w.toDate;
      w.toDate = function(f) {
        return f === "s" && this.$offset ? h(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : S.call(this);
      };
      var y = w.diff;
      w.diff = function(f, C, _) {
        if (f && this.$u === f.$u) return y.call(this, f, C, _);
        var H = this.local(), M = h(f).local();
        return y.call(H, M, C, _);
      };
    };
  });
})(Rt);
var _o = Rt.exports;
const No = /* @__PURE__ */ ut(_o);
var zt = { exports: {} };
(function(e, t) {
  (function(o, n) {
    e.exports = n();
  })(ct, function() {
    var o = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, n = {};
    return function(r, i, l) {
      var h, w = function(T, S, y) {
        y === void 0 && (y = {});
        var f = new Date(T), C = function(_, H) {
          H === void 0 && (H = {});
          var M = H.timeZoneName || "short", q = _ + "|" + M, D = n[q];
          return D || (D = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: _, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: M }), n[q] = D), D;
        }(S, y);
        return C.formatToParts(f);
      }, O = function(T, S) {
        for (var y = w(T, S), f = [], C = 0; C < y.length; C += 1) {
          var _ = y[C], H = _.type, M = _.value, q = o[H];
          q >= 0 && (f[q] = parseInt(M, 10));
        }
        var D = f[3], F = D === 24 ? 0 : D, K = f[0] + "-" + f[1] + "-" + f[2] + " " + F + ":" + f[4] + ":" + f[5] + ":000", re = +T;
        return (l.utc(K).valueOf() - (re -= re % 1e3)) / 6e4;
      }, Y = i.prototype;
      Y.tz = function(T, S) {
        T === void 0 && (T = h);
        var y, f = this.utcOffset(), C = this.toDate(), _ = C.toLocaleString("en-US", { timeZone: T }), H = Math.round((C - new Date(_)) / 1e3 / 60), M = 15 * -Math.round(C.getTimezoneOffset() / 15) - H;
        if (!Number(M)) y = this.utcOffset(0, S);
        else if (y = l(_, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(M, !0), S) {
          var q = y.utcOffset();
          y = y.add(f - q, "minute");
        }
        return y.$x.$timezone = T, y;
      }, Y.offsetName = function(T) {
        var S = this.$x.$timezone || l.tz.guess(), y = w(this.valueOf(), S, { timeZoneName: T }).find(function(f) {
          return f.type.toLowerCase() === "timezonename";
        });
        return y && y.value;
      };
      var z = Y.startOf;
      Y.startOf = function(T, S) {
        if (!this.$x || !this.$x.$timezone) return z.call(this, T, S);
        var y = l(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return z.call(y, T, S).tz(this.$x.$timezone, !0);
      }, l.tz = function(T, S, y) {
        var f = y && S, C = y || S || h, _ = O(+l(), C);
        if (typeof T != "string") return l(T).tz(C);
        var H = function(F, K, re) {
          var X = F - 60 * K * 1e3, P = O(X, re);
          if (K === P) return [X, K];
          var E = O(X -= 60 * (P - K) * 1e3, re);
          return P === E ? [X, P] : [F - 60 * Math.min(P, E) * 1e3, Math.max(P, E)];
        }(l.utc(T, f).valueOf(), _, C), M = H[0], q = H[1], D = l(M).utcOffset(q);
        return D.$x.$timezone = C, D;
      }, l.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, l.tz.setDefault = function(T) {
        h = T;
      };
    };
  });
})(zt);
var Ro = zt.exports;
const zo = /* @__PURE__ */ ut(Ro);
let st;
const v = (e) => st ? st(e) : (console.warn(`Translation called for "${e}" before i18n was initialized.`), e), Ds = (e) => {
  st = e;
};
Ke.extend(No);
Ke.extend(zo);
const Hs = (e, t) => e ? Ke(e).tz(t).format("YYYY-MM-DD HH:mm:ss") : "", _s = (e, t) => e ? Ke(e).tz(t).format("HH:mm") : "", Me = {
  CLOSED: 0,
  NEW: 1,
  PENDING: 2,
  PAID: 3,
  COMPLETE: 4
}, oe = {
  CANCEL: 0,
  NEW: 1,
  PREP: 2,
  SERVED: 3
}, Ns = [
  oe.CANCEL,
  oe.NEW,
  oe.PREP,
  oe.SERVED
], Rs = (e) => ({
  [Me.NEW]: {
    text: (v == null ? void 0 : v("order.status.new")) ?? "新訂單",
    color: "bg-orange-100 text-orange-700"
  },
  [Me.PENDING]: {
    text: (v == null ? void 0 : v("order.status.pending")) ?? "待結帳",
    color: "bg-blue-100 text-blue-700"
  },
  [Me.PAID]: {
    text: (v == null ? void 0 : v("order.status.paid")) ?? "已結帳",
    color: "bg-cyan-100 text-cyan-700"
  },
  [Me.COMPLETE]: {
    text: (v == null ? void 0 : v("order.status.complete")) ?? "已完成",
    color: "bg-green-100 text-green-700"
  },
  [Me.CLOSED]: {
    text: (v == null ? void 0 : v("order.status.closed")) ?? "已關閉",
    color: "bg-red-100 text-red-700"
  }
})[e] ?? {
  text: (v == null ? void 0 : v("common.unknown")) ?? "未知",
  color: "bg-gray-100 text-gray-700"
}, zs = (e) => ({
  [oe.CANCEL]: {
    text: (v == null ? void 0 : v("order.itemStatus.cancel")) ?? "已取消",
    color: "bg-red-100 text-red-700"
  },
  [oe.NEW]: {
    text: (v == null ? void 0 : v("order.itemStatus.new")) ?? "新點單",
    color: "bg-blue-100 text-blue-700"
  },
  [oe.PREP]: {
    text: (v == null ? void 0 : v("order.itemStatus.prep")) ?? "製作中",
    color: "bg-orange-100 text-orange-700"
  },
  [oe.SERVED]: {
    text: (v == null ? void 0 : v("order.itemStatus.served")) ?? "已上菜",
    color: "bg-green-100 text-green-700"
  }
})[e] ?? {
  text: (v == null ? void 0 : v("common.unknown")) ?? "未知",
  color: "bg-gray-100 text-gray-700"
}, jo = {
  [oe.NEW]: {
    // text: '○ 新增',
    text: "○",
    color: "bg-orange-100 text-orange-700"
  },
  [oe.PREP]: {
    // text: '◔ 準備中',
    text: "◔",
    color: "bg-blue-100 text-blue-700"
  },
  [oe.SERVED]: {
    // text: '● 已上菜',
    text: "●",
    color: "bg-green-100 text-green-700"
  },
  [oe.CANCEL]: {
    // text: '✕ 已取消',
    text: "✕",
    color: "bg-red-100 text-red-700"
  }
}, js = (e) => jo[e] ?? {
  text: "未知",
  color: "bg-gray-100 text-gray-700"
};
/*!
* sweetalert2 v11.26.17
* Released under the MIT License.
*/
function jt(e, t, o) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : o;
  throw new TypeError("Private element is not present on this object");
}
function Uo(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Tt(e, t) {
  return e.get(jt(e, t));
}
function Yo(e, t, o) {
  Uo(e, t), t.set(e, o);
}
function Fo(e, t, o) {
  return e.set(jt(e, t), o), o;
}
const Vo = 100, d = {}, Wo = () => {
  d.previousActiveElement instanceof HTMLElement ? (d.previousActiveElement.focus(), d.previousActiveElement = null) : document.body && document.body.focus();
}, qo = (e) => new Promise((t) => {
  if (!e)
    return t();
  const o = window.scrollX, n = window.scrollY;
  d.restoreFocusTimeout = setTimeout(() => {
    Wo(), t();
  }, Vo), window.scrollTo(o, n);
}), Ut = "swal2-", Go = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], s = Go.reduce(
  (e, t) => (e[t] = Ut + t, e),
  /** @type {SwalClasses} */
  {}
), Zo = ["success", "warning", "info", "question", "error"], je = Zo.reduce(
  (e, t) => (e[t] = Ut + t, e),
  /** @type {SwalIcons} */
  {}
), Yt = "SweetAlert2:", dt = (e) => e.charAt(0).toUpperCase() + e.slice(1), V = (e) => {
  console.warn(`${Yt} ${typeof e == "object" ? e.join(" ") : e}`);
}, ge = (e) => {
  console.error(`${Yt} ${e}`);
}, St = [], Ko = (e) => {
  St.includes(e) || (St.push(e), V(e));
}, Ft = (e, t = null) => {
  Ko(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, Xe = (e) => typeof e == "function" ? e() : e, wt = (e) => e && typeof e.toPromise == "function", Be = (e) => wt(e) ? e.toPromise() : Promise.resolve(e), ft = (e) => e && Promise.resolve(e) === e, W = () => document.body.querySelector(`.${s.container}`), Le = (e) => {
  const t = W();
  return t ? t.querySelector(e) : null;
}, Q = (e) => Le(`.${e}`), k = () => Q(s.popup), Ce = () => Q(s.icon), Xo = () => Q(s["icon-content"]), Vt = () => Q(s.title), ht = () => Q(s["html-container"]), Wt = () => Q(s.image), mt = () => Q(s["progress-steps"]), Je = () => Q(s["validation-message"]), ie = () => (
  /** @type {HTMLButtonElement} */
  Le(`.${s.actions} .${s.confirm}`)
), Ae = () => (
  /** @type {HTMLButtonElement} */
  Le(`.${s.actions} .${s.cancel}`)
), be = () => (
  /** @type {HTMLButtonElement} */
  Le(`.${s.actions} .${s.deny}`)
), Jo = () => Q(s["input-label"]), $e = () => Le(`.${s.loader}`), Ie = () => Q(s.actions), qt = () => Q(s.footer), Qe = () => Q(s["timer-progress-bar"]), pt = () => Q(s.close), Qo = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, gt = () => {
  const e = k();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), o = Array.from(t).sort((i, l) => {
    const h = parseInt(i.getAttribute("tabindex") || "0"), w = parseInt(l.getAttribute("tabindex") || "0");
    return h > w ? 1 : h < w ? -1 : 0;
  }), n = e.querySelectorAll(Qo), r = Array.from(n).filter((i) => i.getAttribute("tabindex") !== "-1");
  return [...new Set(o.concat(r))].filter((i) => Z(i));
}, bt = () => ae(document.body, s.shown) && !ae(document.body, s["toast-shown"]) && !ae(document.body, s["no-backdrop"]), et = () => {
  const e = k();
  return e ? ae(e, s.toast) : !1;
}, en = () => {
  const e = k();
  return e ? e.hasAttribute("data-loading") : !1;
}, ee = (e, t) => {
  if (e.textContent = "", t) {
    const n = new DOMParser().parseFromString(t, "text/html"), r = n.querySelector("head");
    r && Array.from(r.childNodes).forEach((l) => {
      e.appendChild(l);
    });
    const i = n.querySelector("body");
    i && Array.from(i.childNodes).forEach((l) => {
      l instanceof HTMLVideoElement || l instanceof HTMLAudioElement ? e.appendChild(l.cloneNode(!0)) : e.appendChild(l);
    });
  }
}, ae = (e, t) => {
  if (!t)
    return !1;
  const o = t.split(/\s+/);
  for (let n = 0; n < o.length; n++)
    if (!e.classList.contains(o[n]))
      return !1;
  return !0;
}, tn = (e, t) => {
  Array.from(e.classList).forEach((o) => {
    !Object.values(s).includes(o) && !Object.values(je).includes(o) && !Object.values(t.showClass || {}).includes(o) && e.classList.remove(o);
  });
}, J = (e, t, o) => {
  if (tn(e, t), !t.customClass)
    return;
  const n = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    o
  ];
  if (n) {
    if (typeof n != "string" && !n.forEach) {
      V(`Invalid type of customClass.${o}! Expected string or iterable object, got "${typeof n}"`);
      return;
    }
    x(e, n);
  }
}, tt = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${s.popup} > .${s[t]}`);
    case "checkbox":
      return e.querySelector(`.${s.popup} > .${s.checkbox} input`);
    case "radio":
      return e.querySelector(`.${s.popup} > .${s.radio} input:checked`) || e.querySelector(`.${s.popup} > .${s.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${s.popup} > .${s.range} input`);
    default:
      return e.querySelector(`.${s.popup} > .${s.input}`);
  }
}, Gt = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, Zt = (e, t, o) => {
  !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((n) => {
    Array.isArray(e) ? e.forEach((r) => {
      o ? r.classList.add(n) : r.classList.remove(n);
    }) : o ? e.classList.add(n) : e.classList.remove(n);
  }));
}, x = (e, t) => {
  Zt(e, t, !0);
}, ne = (e, t) => {
  Zt(e, t, !1);
}, ce = (e, t) => {
  const o = Array.from(e.children);
  for (let n = 0; n < o.length; n++) {
    const r = o[n];
    if (r instanceof HTMLElement && ae(r, t))
      return r;
  }
}, me = (e, t, o) => {
  o === `${parseInt(`${o}`)}` && (o = parseInt(o)), o || parseInt(`${o}`) === 0 ? e.style.setProperty(t, typeof o == "number" ? `${o}px` : (
    /** @type {string} */
    o
  )) : e.style.removeProperty(t);
}, R = (e, t = "flex") => {
  e && (e.style.display = t);
}, U = (e) => {
  e && (e.style.display = "none");
}, vt = (e, t = "block") => {
  e && new MutationObserver(() => {
    De(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, Pt = (e, t, o, n) => {
  const r = e.querySelector(t);
  r && r.style.setProperty(o, n);
}, De = (e, t, o = "flex") => {
  t ? R(e, o) : U(e);
}, Z = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), on = () => !Z(ie()) && !Z(be()) && !Z(Ae()), it = (e) => e.scrollHeight > e.clientHeight, nn = (e, t) => {
  let o = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; o && o !== t; ) {
    if (it(o))
      return !0;
    o = o.parentElement;
  }
  return !1;
}, Kt = (e) => {
  const t = window.getComputedStyle(e), o = parseFloat(t.getPropertyValue("animation-duration") || "0"), n = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return o > 0 || n > 0;
}, yt = (e, t = !1) => {
  const o = Qe();
  o && Z(o) && (t && (o.style.transition = "none", o.style.width = "100%"), setTimeout(() => {
    o.style.transition = `width ${e / 1e3}s linear`, o.style.width = "0%";
  }, 10));
}, rn = () => {
  const e = Qe();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const o = parseInt(window.getComputedStyle(e).width), n = t / o * 100;
  e.style.width = `${n}%`;
}, sn = () => typeof window > "u" || typeof document > "u", an = `
 <div aria-labelledby="${s.title}" aria-describedby="${s["html-container"]}" class="${s.popup}" tabindex="-1">
   <button type="button" class="${s.close}"></button>
   <ul class="${s["progress-steps"]}"></ul>
   <div class="${s.icon}"></div>
   <img class="${s.image}" />
   <h2 class="${s.title}" id="${s.title}"></h2>
   <div class="${s["html-container"]}" id="${s["html-container"]}"></div>
   <input class="${s.input}" id="${s.input}" />
   <input type="file" class="${s.file}" />
   <div class="${s.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${s.select}" id="${s.select}"></select>
   <div class="${s.radio}"></div>
   <label class="${s.checkbox}">
     <input type="checkbox" id="${s.checkbox}" />
     <span class="${s.label}"></span>
   </label>
   <textarea class="${s.textarea}" id="${s.textarea}"></textarea>
   <div class="${s["validation-message"]}" id="${s["validation-message"]}"></div>
   <div class="${s.actions}">
     <div class="${s.loader}"></div>
     <button type="button" class="${s.confirm}"></button>
     <button type="button" class="${s.deny}"></button>
     <button type="button" class="${s.cancel}"></button>
   </div>
   <div class="${s.footer}"></div>
   <div class="${s["timer-progress-bar-container"]}">
     <div class="${s["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), ln = () => {
  const e = W();
  return e ? (e.remove(), ne([document.documentElement, document.body], [
    s["no-backdrop"],
    s["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    s["has-column"]
  ]), !0) : !1;
}, he = () => {
  d.currentInstance && d.currentInstance.resetValidationMessage();
}, cn = () => {
  const e = k();
  if (!e)
    return;
  const t = ce(e, s.input), o = ce(e, s.file), n = e.querySelector(`.${s.range} input`), r = e.querySelector(`.${s.range} output`), i = ce(e, s.select), l = e.querySelector(`.${s.checkbox} input`), h = ce(e, s.textarea);
  t && (t.oninput = he), o && (o.onchange = he), i && (i.onchange = he), l && (l.onchange = he), h && (h.oninput = he), n && r && (n.oninput = () => {
    he(), r.value = n.value;
  }, n.onchange = () => {
    he(), r.value = n.value;
  });
}, un = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, dn = (e) => {
  const t = k();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, wn = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (x(W(), s.rtl), d.isRTL = !0);
}, fn = (e) => {
  const t = ln();
  if (sn()) {
    ge("SweetAlert2 requires document to initialize");
    return;
  }
  const o = document.createElement("div");
  o.className = s.container, t && x(o, s["no-transition"]), ee(o, an), o.dataset.swal2Theme = e.theme;
  const n = un(e.target || "body");
  n.appendChild(o), e.topLayer && (o.setAttribute("popover", ""), o.showPopover()), dn(e), wn(n), cn();
}, Et = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? hn(e, t) : e && ee(t, e);
}, hn = (e, t) => {
  "jquery" in e ? mn(t, e) : ee(t, e.toString());
}, mn = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let o = 0; o in t; o++)
      e.appendChild(t[o].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, pn = (e, t) => {
  const o = Ie(), n = $e();
  !o || !n || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? U(o) : R(o), J(o, t, "actions"), gn(o, n, t), ee(n, t.loaderHtml || ""), J(n, t, "loader"));
};
function gn(e, t, o) {
  const n = ie(), r = be(), i = Ae();
  !n || !r || !i || (nt(n, "confirm", o), nt(r, "deny", o), nt(i, "cancel", o), bn(n, r, i, o), o.reverseButtons && (o.toast ? (e.insertBefore(i, n), e.insertBefore(r, n)) : (e.insertBefore(i, t), e.insertBefore(r, t), e.insertBefore(n, t))));
}
function bn(e, t, o, n) {
  if (!n.buttonsStyling) {
    ne([e, t, o], s.styled);
    return;
  }
  x([e, t, o], s.styled), n.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", n.confirmButtonColor), n.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", n.denyButtonColor), n.cancelButtonColor && o.style.setProperty("--swal2-cancel-button-background-color", n.cancelButtonColor), ot(e), ot(t), ot(o);
}
function ot(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const o = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${o}`));
}
function nt(e, t, o) {
  const n = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    dt(t)
  );
  De(e, o[`show${n}Button`], "inline-block"), ee(e, o[`${t}ButtonText`] || ""), e.setAttribute("aria-label", o[`${t}ButtonAriaLabel`] || ""), e.className = s[t], J(e, o, `${t}Button`);
}
const vn = (e, t) => {
  const o = pt();
  o && (ee(o, t.closeButtonHtml || ""), J(o, t, "closeButton"), De(o, t.showCloseButton), o.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, yn = (e, t) => {
  const o = W();
  o && (En(o, t.backdrop), xn(o, t.position), kn(o, t.grow), J(o, t, "container"));
};
function En(e, t) {
  typeof t == "string" ? e.style.background = t : t || x([document.documentElement, document.body], s["no-backdrop"]);
}
function xn(e, t) {
  t && (t in s ? x(e, s[t]) : (V('The "position" parameter is not valid, defaulting to "center"'), x(e, s.center)));
}
function kn(e, t) {
  t && x(e, s[`grow-${t}`]);
}
var $ = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap()
};
const Cn = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], An = (e, t) => {
  const o = k();
  if (!o)
    return;
  const n = $.innerParams.get(e), r = !n || t.input !== n.input;
  Cn.forEach((i) => {
    const l = ce(o, s[i]);
    l && (Sn(i, t.inputAttributes), l.className = s[i], r && U(l));
  }), t.input && (r && $n(t), Pn(t));
}, $n = (e) => {
  if (!e.input)
    return;
  if (!L[e.input]) {
    ge(`Unexpected type of input! Expected ${Object.keys(L).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = Xt(e.input);
  if (!t)
    return;
  const o = L[e.input](t, e);
  R(t), e.inputAutoFocus && setTimeout(() => {
    Gt(o);
  });
}, Tn = (e) => {
  for (let t = 0; t < e.attributes.length; t++) {
    const o = e.attributes[t].name;
    ["id", "type", "value", "style"].includes(o) || e.removeAttribute(o);
  }
}, Sn = (e, t) => {
  const o = k();
  if (!o)
    return;
  const n = tt(o, e);
  if (n) {
    Tn(n);
    for (const r in t)
      n.setAttribute(r, t[r]);
  }
}, Pn = (e) => {
  if (!e.input)
    return;
  const t = Xt(e.input);
  t && J(t, e, "input");
}, xt = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, He = (e, t, o) => {
  if (o.inputLabel) {
    const n = document.createElement("label"), r = s["input-label"];
    n.setAttribute("for", e.id), n.className = r, typeof o.customClass == "object" && x(n, o.customClass.inputLabel), n.innerText = o.inputLabel, t.insertAdjacentElement("beforebegin", n);
  }
}, Xt = (e) => {
  const t = k();
  if (t)
    return ce(t, s[
      /** @type {SwalClass} */
      e
    ] || s.input);
}, Ue = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : ft(t) || V(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, L = {};
L.text = L.email = L.password = L.number = L.tel = L.url = L.search = L.date = L["datetime-local"] = L.time = L.week = L.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const o = (
    /** @type {HTMLInputElement} */
    e
  );
  return Ue(o, t.inputValue), He(o, o, t), xt(o, t), o.type = /** @type {string} */
  t.input, o;
};
L.file = (e, t) => {
  const o = (
    /** @type {HTMLInputElement} */
    e
  );
  return He(o, o, t), xt(o, t), o;
};
L.range = (e, t) => {
  const o = (
    /** @type {HTMLElement} */
    e
  ), n = o.querySelector("input"), r = o.querySelector("output");
  return n && (Ue(n, t.inputValue), n.type = /** @type {string} */
  t.input, He(
    n,
    /** @type {Input} */
    e,
    t
  )), r && Ue(r, t.inputValue), /** @type {Input} */
  e;
};
L.select = (e, t) => {
  const o = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (o.textContent = "", t.inputPlaceholder) {
    const n = document.createElement("option");
    ee(n, t.inputPlaceholder), n.value = "", n.disabled = !0, n.selected = !0, o.appendChild(n);
  }
  return He(o, o, t), o;
};
L.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
L.checkbox = (e, t) => {
  const o = k();
  if (!o)
    throw new Error("Popup not found");
  const n = tt(o, "checkbox");
  if (!n)
    throw new Error("Checkbox input not found");
  n.value = "1", n.checked = !!t.inputValue;
  const i = /** @type {HTMLElement} */ e.querySelector("span");
  if (i) {
    const l = t.inputPlaceholder || t.inputLabel;
    l && ee(i, l);
  }
  return n;
};
L.textarea = (e, t) => {
  const o = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  Ue(o, t.inputValue), xt(o, t), He(o, o, t);
  const n = (r) => parseInt(window.getComputedStyle(r).marginLeft) + parseInt(window.getComputedStyle(r).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const r = k();
      if (!r)
        return;
      const i = parseInt(window.getComputedStyle(r).width), l = () => {
        if (!document.body.contains(o))
          return;
        const h = o.offsetWidth + n(o), w = k();
        w && (h > i ? w.style.width = `${h}px` : me(w, "width", t.width));
      };
      new MutationObserver(l).observe(o, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), o;
};
const Mn = (e, t) => {
  const o = ht();
  o && (vt(o), J(o, t, "htmlContainer"), t.html ? (Et(t.html, o), R(o, "block")) : t.text ? (o.textContent = t.text, R(o, "block")) : U(o), An(e, t));
}, On = (e, t) => {
  const o = qt();
  o && (vt(o), De(o, !!t.footer, "block"), t.footer && Et(t.footer, o), J(o, t, "footer"));
}, Bn = (e, t) => {
  const o = $.innerParams.get(e), n = Ce();
  if (!n)
    return;
  if (o && t.icon === o.icon) {
    Ot(n, t), Mt(n, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    U(n);
    return;
  }
  if (t.icon && Object.keys(je).indexOf(t.icon) === -1) {
    ge(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), U(n);
    return;
  }
  R(n), Ot(n, t), Mt(n, t), x(n, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Jt);
}, Mt = (e, t) => {
  for (const [o, n] of Object.entries(je))
    t.icon !== o && ne(e, n);
  x(e, t.icon && je[t.icon]), Dn(e, t), Jt(), J(e, t, "icon");
}, Jt = () => {
  const e = k();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color"), o = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
  for (let n = 0; n < o.length; n++)
    o[n].style.backgroundColor = t;
}, Ln = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, In = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, Ot = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let o = e.innerHTML, n = "";
  t.iconHtml ? n = Bt(t.iconHtml) : t.icon === "success" ? (n = Ln(t), o = o.replace(/ style=".*?"/g, "")) : t.icon === "error" ? n = In : t.icon && (n = Bt({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), o.trim() !== n.trim() && ee(e, n);
}, Dn = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const o of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      Pt(e, o, "background-color", t.iconColor);
    Pt(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, Bt = (e) => `<div class="${s["icon-content"]}">${e}</div>`, Hn = (e, t) => {
  const o = Wt();
  if (o) {
    if (!t.imageUrl) {
      U(o);
      return;
    }
    R(o, ""), o.setAttribute("src", t.imageUrl), o.setAttribute("alt", t.imageAlt || ""), me(o, "width", t.imageWidth), me(o, "height", t.imageHeight), o.className = s.image, J(o, t, "image");
  }
};
let kt = !1, Qt = 0, eo = 0, to = 0, oo = 0;
const _n = (e) => {
  e.addEventListener("mousedown", Ye), document.body.addEventListener("mousemove", Fe), e.addEventListener("mouseup", Ve), e.addEventListener("touchstart", Ye), document.body.addEventListener("touchmove", Fe), e.addEventListener("touchend", Ve);
}, Nn = (e) => {
  e.removeEventListener("mousedown", Ye), document.body.removeEventListener("mousemove", Fe), e.removeEventListener("mouseup", Ve), e.removeEventListener("touchstart", Ye), document.body.removeEventListener("touchmove", Fe), e.removeEventListener("touchend", Ve);
}, Ye = (e) => {
  const t = k();
  if (!t)
    return;
  const o = Ce();
  if (e.target === t || o && o.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    kt = !0;
    const n = no(e);
    Qt = n.clientX, eo = n.clientY, to = parseInt(t.style.insetInlineStart) || 0, oo = parseInt(t.style.insetBlockStart) || 0, x(t, "swal2-dragging");
  }
}, Fe = (e) => {
  const t = k();
  if (t && kt) {
    let {
      clientX: o,
      clientY: n
    } = no(e);
    const r = o - Qt;
    t.style.insetInlineStart = `${to + (d.isRTL ? -r : r)}px`, t.style.insetBlockStart = `${oo + (n - eo)}px`;
  }
}, Ve = () => {
  const e = k();
  kt = !1, ne(e, "swal2-dragging");
}, no = (e) => {
  let t = 0, o = 0;
  return e.type.startsWith("mouse") ? (t = /** @type {MouseEvent} */
  e.clientX, o = /** @type {MouseEvent} */
  e.clientY) : e.type.startsWith("touch") && (t = /** @type {TouchEvent} */
  e.touches[0].clientX, o = /** @type {TouchEvent} */
  e.touches[0].clientY), {
    clientX: t,
    clientY: o
  };
}, Rn = (e, t) => {
  const o = W(), n = k();
  if (!(!o || !n)) {
    if (t.toast) {
      me(o, "width", t.width), n.style.width = "100%";
      const r = $e();
      r && n.insertBefore(r, Ce());
    } else
      me(n, "width", t.width);
    me(n, "padding", t.padding), t.color && (n.style.color = t.color), t.background && (n.style.background = t.background), U(Je()), zn(n, t), t.draggable && !t.toast ? (x(n, s.draggable), _n(n)) : (ne(n, s.draggable), Nn(n));
  }
}, zn = (e, t) => {
  const o = t.showClass || {};
  e.className = `${s.popup} ${Z(e) ? o.popup : ""}`, t.toast ? (x([document.documentElement, document.body], s["toast-shown"]), x(e, s.toast)) : x(e, s.modal), J(e, t, "popup"), typeof t.customClass == "string" && x(e, t.customClass), t.icon && x(e, s[`icon-${t.icon}`]);
}, jn = (e, t) => {
  const o = mt();
  if (!o)
    return;
  const {
    progressSteps: n,
    currentProgressStep: r
  } = t;
  if (!n || n.length === 0 || r === void 0) {
    U(o);
    return;
  }
  R(o), o.textContent = "", r >= n.length && V("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), n.forEach((i, l) => {
    const h = Un(i);
    if (o.appendChild(h), l === r && x(h, s["active-progress-step"]), l !== n.length - 1) {
      const w = Yn(t);
      o.appendChild(w);
    }
  });
}, Un = (e) => {
  const t = document.createElement("li");
  return x(t, s["progress-step"]), ee(t, e), t;
}, Yn = (e) => {
  const t = document.createElement("li");
  return x(t, s["progress-step-line"]), e.progressStepsDistance && me(t, "width", e.progressStepsDistance), t;
}, Fn = (e, t) => {
  const o = Vt();
  o && (vt(o), De(o, !!(t.title || t.titleText), "block"), t.title && Et(t.title, o), t.titleText && (o.innerText = t.titleText), J(o, t, "title"));
}, ro = (e, t) => {
  var o;
  Rn(e, t), yn(e, t), jn(e, t), Bn(e, t), Hn(e, t), Fn(e, t), vn(e, t), Mn(e, t), pn(e, t), On(e, t);
  const n = k();
  typeof t.didRender == "function" && n && t.didRender(n), (o = d.eventEmitter) === null || o === void 0 || o.emit("didRender", n);
}, Vn = () => Z(k()), so = () => {
  var e;
  return (e = ie()) === null || e === void 0 ? void 0 : e.click();
}, Wn = () => {
  var e;
  return (e = be()) === null || e === void 0 ? void 0 : e.click();
}, qn = () => {
  var e;
  return (e = Ae()) === null || e === void 0 ? void 0 : e.click();
}, Te = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), io = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, Gn = (e, t, o) => {
  if (io(e), !t.toast) {
    const n = (i) => Kn(t, i, o);
    e.keydownHandler = n;
    const r = t.keydownListenerCapture ? window : k();
    if (r) {
      e.keydownTarget = r, e.keydownListenerCapture = t.keydownListenerCapture;
      const i = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        n
      );
      e.keydownTarget.addEventListener("keydown", i, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, at = (e, t) => {
  var o;
  const n = gt();
  if (n.length) {
    e = e + t, e === -2 && (e = n.length - 1), e === n.length ? e = 0 : e === -1 && (e = n.length - 1), n[e].focus();
    return;
  }
  (o = k()) === null || o === void 0 || o.focus();
}, ao = ["ArrowRight", "ArrowDown"], Zn = ["ArrowLeft", "ArrowUp"], Kn = (e, t, o) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? Xn(t, e) : t.key === "Tab" ? Jn(t) : [...ao, ...Zn].includes(t.key) ? Qn(t.key) : t.key === "Escape" && er(t, e, o)));
}, Xn = (e, t) => {
  if (!Xe(t.allowEnterKey))
    return;
  const o = k();
  if (!o || !t.input)
    return;
  const n = tt(o, t.input);
  if (e.target && n && e.target instanceof HTMLElement && e.target.outerHTML === n.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    so(), e.preventDefault();
  }
}, Jn = (e) => {
  const t = e.target, o = gt();
  let n = -1;
  for (let r = 0; r < o.length; r++)
    if (t === o[r]) {
      n = r;
      break;
    }
  e.shiftKey ? at(n, -1) : at(n, 1), e.stopPropagation(), e.preventDefault();
}, Qn = (e) => {
  const t = Ie(), o = ie(), n = be(), r = Ae();
  if (!t || !o || !n || !r)
    return;
  const i = [o, n, r];
  if (document.activeElement instanceof HTMLElement && !i.includes(document.activeElement))
    return;
  const l = ao.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let h = document.activeElement;
  if (h) {
    for (let w = 0; w < t.children.length; w++) {
      if (h = h[l], !h)
        return;
      if (h instanceof HTMLButtonElement && Z(h))
        break;
    }
    h instanceof HTMLButtonElement && h.focus();
  }
}, er = (e, t, o) => {
  e.preventDefault(), Xe(t.allowEscapeKey) && o(Te.esc);
};
var Ee = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const tr = () => {
  const e = W();
  Array.from(document.body.children).forEach((o) => {
    o.contains(e) || (o.hasAttribute("aria-hidden") && o.setAttribute("data-previous-aria-hidden", o.getAttribute("aria-hidden") || ""), o.setAttribute("aria-hidden", "true"));
  });
}, lo = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, co = typeof window < "u" && !!window.GestureEvent, or = () => {
  if (co && !ae(document.body, s.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, x(document.body, s.iosfix), nr();
  }
}, nr = () => {
  const e = W();
  if (!e)
    return;
  let t;
  e.ontouchstart = (o) => {
    t = rr(o);
  }, e.ontouchmove = (o) => {
    t && (o.preventDefault(), o.stopPropagation());
  };
}, rr = (e) => {
  const t = e.target, o = W(), n = ht();
  return !o || !n || sr(e) || ir(e) ? !1 : t === o || !it(o) && t instanceof HTMLElement && !nn(t, n) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(it(n) && // #1944
  n.contains(t));
}, sr = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), ir = (e) => e.touches && e.touches.length > 1, ar = () => {
  if (ae(document.body, s.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    ne(document.body, s.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, lr = () => {
  const e = document.createElement("div");
  e.className = s["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let ye = null;
const cr = (e) => {
  ye === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (ye = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${ye + lr()}px`);
}, ur = () => {
  ye !== null && (document.body.style.paddingRight = `${ye}px`, ye = null);
};
function uo(e, t, o, n) {
  et() ? Lt(e, n) : (qo(o).then(() => Lt(e, n)), io(d)), co ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), bt() && (ur(), ar(), lo()), dr();
}
function dr() {
  ne([document.documentElement, document.body], [s.shown, s["height-auto"], s["no-backdrop"], s["toast-shown"]]);
}
function ue(e) {
  e = fr(e);
  const t = Ee.swalPromiseResolve.get(this), o = wr(this);
  this.isAwaitingPromise ? e.isDismissed || (_e(this), t(e)) : o && t(e);
}
const wr = (e) => {
  const t = k();
  if (!t)
    return !1;
  const o = $.innerParams.get(e);
  if (!o || ae(t, o.hideClass.popup))
    return !1;
  ne(t, o.showClass.popup), x(t, o.hideClass.popup);
  const n = W();
  return ne(n, o.showClass.backdrop), x(n, o.hideClass.backdrop), hr(e, t, o), !0;
};
function wo(e) {
  const t = Ee.swalPromiseReject.get(this);
  _e(this), t && t(e);
}
const _e = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, $.innerParams.get(e) || e._destroy());
}, fr = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), hr = (e, t, o) => {
  var n;
  const r = W(), i = Kt(t);
  typeof o.willClose == "function" && o.willClose(t), (n = d.eventEmitter) === null || n === void 0 || n.emit("willClose", t), i && r ? mr(e, t, r, !!o.returnFocus, o.didClose) : r && uo(e, r, !!o.returnFocus, o.didClose);
}, mr = (e, t, o, n, r) => {
  d.swalCloseEventFinishedCallback = uo.bind(null, e, o, n, r);
  const i = function(l) {
    if (l.target === t) {
      var h;
      (h = d.swalCloseEventFinishedCallback) === null || h === void 0 || h.call(d), delete d.swalCloseEventFinishedCallback, t.removeEventListener("animationend", i), t.removeEventListener("transitionend", i);
    }
  };
  t.addEventListener("animationend", i), t.addEventListener("transitionend", i);
}, Lt = (e, t) => {
  setTimeout(() => {
    var o;
    typeof t == "function" && t.bind(e.params)(), (o = d.eventEmitter) === null || o === void 0 || o.emit("didClose"), e._destroy && e._destroy();
  });
}, xe = (e) => {
  let t = k();
  if (t || new ke(), t = k(), !t)
    return;
  const o = $e();
  et() ? U(Ce()) : pr(t, e), R(o), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, pr = (e, t) => {
  const o = Ie(), n = $e();
  !o || !n || (!t && Z(ie()) && (t = ie()), R(o), t && (U(t), n.setAttribute("data-button-to-replace", t.className), o.insertBefore(n, t)), x([e, o], s.loading));
}, gr = (e, t) => {
  t.input === "select" || t.input === "radio" ? xr(e, t) : ["text", "email", "number", "tel", "textarea"].some((o) => o === t.input) && (wt(t.inputValue) || ft(t.inputValue)) && (xe(ie()), kr(e, t));
}, br = (e, t) => {
  const o = e.getInput();
  if (!o)
    return null;
  switch (t.input) {
    case "checkbox":
      return vr(o);
    case "radio":
      return yr(o);
    case "file":
      return Er(o);
    default:
      return t.inputAutoTrim ? o.value.trim() : o.value;
  }
}, vr = (e) => e.checked ? 1 : 0, yr = (e) => e.checked ? e.value : null, Er = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, xr = (e, t) => {
  const o = k();
  if (!o)
    return;
  const n = (r) => {
    t.input === "select" ? Cr(o, We(r), t) : t.input === "radio" && Ar(o, We(r), t);
  };
  wt(t.inputOptions) || ft(t.inputOptions) ? (xe(ie()), Be(t.inputOptions).then((r) => {
    e.hideLoading(), n(r);
  })) : typeof t.inputOptions == "object" ? n(t.inputOptions) : ge(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, kr = (e, t) => {
  const o = e.getInput();
  o && (U(o), Be(t.inputValue).then((n) => {
    o.value = t.input === "number" ? `${parseFloat(n) || 0}` : `${n}`, R(o), o.focus(), e.hideLoading();
  }).catch((n) => {
    ge(`Error in inputValue promise: ${n}`), o.value = "", R(o), o.focus(), e.hideLoading();
  }));
};
function Cr(e, t, o) {
  const n = ce(e, s.select);
  if (!n)
    return;
  const r = (i, l, h) => {
    const w = document.createElement("option");
    w.value = h, ee(w, l), w.selected = fo(h, o.inputValue), i.appendChild(w);
  };
  t.forEach((i) => {
    const l = i[0], h = i[1];
    if (Array.isArray(h)) {
      const w = document.createElement("optgroup");
      w.label = l, w.disabled = !1, n.appendChild(w), h.forEach((O) => r(w, O[1], O[0]));
    } else
      r(n, h, l);
  }), n.focus();
}
function Ar(e, t, o) {
  const n = ce(e, s.radio);
  if (!n)
    return;
  t.forEach((i) => {
    const l = i[0], h = i[1], w = document.createElement("input"), O = document.createElement("label");
    w.type = "radio", w.name = s.radio, w.value = l, fo(l, o.inputValue) && (w.checked = !0);
    const Y = document.createElement("span");
    ee(Y, h), Y.className = s.label, O.appendChild(w), O.appendChild(Y), n.appendChild(O);
  });
  const r = n.querySelectorAll("input");
  r.length && r[0].focus();
}
const We = (e) => {
  const t = [];
  return e instanceof Map ? e.forEach((o, n) => {
    let r = o;
    typeof r == "object" && (r = We(r)), t.push([n, r]);
  }) : Object.keys(e).forEach((o) => {
    let n = e[o];
    typeof n == "object" && (n = We(n)), t.push([o, n]);
  }), t;
}, fo = (e, t) => !!t && t !== null && t !== void 0 && t.toString() === e.toString(), $r = (e) => {
  const t = $.innerParams.get(e);
  e.disableButtons(), t.input ? ho(e, "confirm") : At(e, !0);
}, Tr = (e) => {
  const t = $.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? ho(e, "deny") : Ct(e, !1);
}, Sr = (e, t) => {
  e.disableButtons(), t(Te.cancel);
}, ho = (e, t) => {
  const o = $.innerParams.get(e);
  if (!o.input) {
    ge(`The "input" parameter is needed to be set when using returnInputValueOn${dt(t)}`);
    return;
  }
  const n = e.getInput(), r = br(e, o);
  o.inputValidator ? Pr(e, r, t) : n && !n.checkValidity() ? (e.enableButtons(), e.showValidationMessage(o.validationMessage || n.validationMessage)) : t === "deny" ? Ct(e, r) : At(e, r);
}, Pr = (e, t, o) => {
  const n = $.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Be(n.inputValidator(t, n.validationMessage))).then((i) => {
    e.enableButtons(), e.enableInput(), i ? e.showValidationMessage(i) : o === "deny" ? Ct(e, t) : At(e, t);
  });
}, Ct = (e, t) => {
  const o = $.innerParams.get(e);
  o.showLoaderOnDeny && xe(be()), o.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Be(o.preDeny(t, o.validationMessage))).then((r) => {
    r === !1 ? (e.hideLoading(), _e(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof r > "u" ? t : r
      }
    );
  }).catch((r) => mo(e, r))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, It = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, mo = (e, t) => {
  e.rejectPromise(t);
}, At = (e, t) => {
  const o = $.innerParams.get(e);
  o.showLoaderOnConfirm && xe(), o.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Be(o.preConfirm(t, o.validationMessage))).then((r) => {
    Z(Je()) || r === !1 ? (e.hideLoading(), _e(e)) : It(e, typeof r > "u" ? t : r);
  }).catch((r) => mo(e, r))) : It(e, t);
};
function qe() {
  const e = $.innerParams.get(this);
  if (!e)
    return;
  const t = $.domCache.get(this);
  U(t.loader), et() ? e.icon && R(Ce()) : Mr(t), ne([t.popup, t.actions], s.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
}
const Mr = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), o = t ? e.popup.getElementsByClassName(t) : [];
  o.length ? R(
    /** @type {HTMLElement} */
    o[0],
    "inline-block"
  ) : on() && U(e.actions);
};
function po() {
  const e = $.innerParams.get(this), t = $.domCache.get(this);
  return t ? tt(t.popup, e.input) : null;
}
function go(e, t, o) {
  const n = $.domCache.get(e);
  t.forEach((r) => {
    n[r].disabled = o;
  });
}
function bo(e, t) {
  const o = k();
  if (!(!o || !e))
    if (e.type === "radio") {
      const n = o.querySelectorAll(`[name="${s.radio}"]`);
      for (let r = 0; r < n.length; r++)
        n[r].disabled = t;
    } else
      e.disabled = t;
}
function vo() {
  go(this, ["confirmButton", "denyButton", "cancelButton"], !1);
}
function yo() {
  go(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function Eo() {
  bo(this.getInput(), !1);
}
function xo() {
  bo(this.getInput(), !0);
}
function ko(e) {
  const t = $.domCache.get(this), o = $.innerParams.get(this);
  ee(t.validationMessage, e), t.validationMessage.className = s["validation-message"], o.customClass && o.customClass.validationMessage && x(t.validationMessage, o.customClass.validationMessage), R(t.validationMessage);
  const n = this.getInput();
  n && (n.setAttribute("aria-invalid", "true"), n.setAttribute("aria-describedby", s["validation-message"]), Gt(n), x(n, s.inputerror));
}
function Co() {
  const e = $.domCache.get(this);
  e.validationMessage && U(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), ne(t, s.inputerror));
}
const de = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, Or = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], Br = {
  allowEnterKey: void 0
}, Lr = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], Ao = (e) => Object.prototype.hasOwnProperty.call(de, e), $o = (e) => Or.indexOf(e) !== -1, To = (e) => Br[e], Ir = (e) => {
  Ao(e) || V(`Unknown parameter "${e}"`);
}, Dr = (e) => {
  Lr.includes(e) && V(`The parameter "${e}" is incompatible with toasts`);
}, Hr = (e) => {
  const t = To(e);
  t && Ft(e, t);
}, So = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && V('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && V(`Invalid theme "${e.theme}"`);
  for (const t in e)
    Ir(t), e.toast && Dr(t), Hr(t);
};
function Po(e) {
  const t = W(), o = k(), n = $.innerParams.get(this);
  if (!o || ae(o, n.hideClass.popup)) {
    V("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const r = _r(e), i = Object.assign({}, n, r);
  So(i), t && (t.dataset.swal2Theme = i.theme), ro(this, i), $.innerParams.set(this, i), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const _r = (e) => {
  const t = {};
  return Object.keys(e).forEach((o) => {
    if ($o(o)) {
      const n = (
        /** @type {Record<string, any>} */
        e
      );
      t[o] = n[o];
    } else
      V(`Invalid parameter to update: ${o}`);
  }), t;
};
function Mo() {
  var e;
  const t = $.domCache.get(this), o = $.innerParams.get(this);
  if (!o) {
    Oo(this);
    return;
  }
  t.popup && d.swalCloseEventFinishedCallback && (d.swalCloseEventFinishedCallback(), delete d.swalCloseEventFinishedCallback), typeof o.didDestroy == "function" && o.didDestroy(), (e = d.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), Nr(this);
}
const Nr = (e) => {
  Oo(e), delete e.params, delete d.keydownHandler, delete d.keydownTarget, delete d.currentInstance;
}, Oo = (e) => {
  e.isAwaitingPromise ? (rt($, e), e.isAwaitingPromise = !0) : (rt(Ee, e), rt($, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, rt = (e, t) => {
  for (const o in e)
    e[o].delete(t);
};
var Rr = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: Mo,
  close: ue,
  closeModal: ue,
  closePopup: ue,
  closeToast: ue,
  disableButtons: yo,
  disableInput: xo,
  disableLoading: qe,
  enableButtons: vo,
  enableInput: Eo,
  getInput: po,
  handleAwaitingPromise: _e,
  hideLoading: qe,
  rejectPromise: wo,
  resetValidationMessage: Co,
  showValidationMessage: ko,
  update: Po
});
const zr = (e, t, o) => {
  e.toast ? jr(e, t, o) : (Yr(t), Fr(t), Vr(e, t, o));
}, jr = (e, t, o) => {
  t.popup.onclick = () => {
    e && (Ur(e) || e.timer || e.input) || o(Te.close);
  };
}, Ur = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let Ge = !1;
const Yr = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (Ge = !0);
    };
  };
}, Fr = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(o) {
      e.popup.onmouseup = () => {
      }, (o.target === e.popup || o.target instanceof HTMLElement && e.popup.contains(o.target)) && (Ge = !0);
    };
  };
}, Vr = (e, t, o) => {
  t.container.onclick = (n) => {
    if (Ge) {
      Ge = !1;
      return;
    }
    n.target === t.container && Xe(e.allowOutsideClick) && o(Te.backdrop);
  };
}, Wr = (e) => typeof e == "object" && e.jquery, Dt = (e) => e instanceof Element || Wr(e), qr = (e) => {
  const t = {};
  return typeof e[0] == "object" && !Dt(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((o, n) => {
    const r = e[n];
    typeof r == "string" || Dt(r) ? t[o] = r : r !== void 0 && ge(`Unexpected type of ${o}! Expected "string" or "Element", got ${typeof r}`);
  }), t;
};
function Gr(...e) {
  return new this(...e);
}
function Zr(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(n, r) {
      return super._main(n, Object.assign({}, e, r));
    }
  }
  return t;
}
const Kr = () => d.timeout && d.timeout.getTimerLeft(), Bo = () => {
  if (d.timeout)
    return rn(), d.timeout.stop();
}, Lo = () => {
  if (d.timeout) {
    const e = d.timeout.start();
    return yt(e), e;
  }
}, Xr = () => {
  const e = d.timeout;
  return e && (e.running ? Bo() : Lo());
}, Jr = (e) => {
  if (d.timeout) {
    const t = d.timeout.increase(e);
    return yt(t, !0), t;
  }
}, Qr = () => !!(d.timeout && d.timeout.isRunning());
let Ht = !1;
const lt = {};
function es(e = "data-swal-template") {
  lt[e] = this, Ht || (document.body.addEventListener("click", ts), Ht = !0);
}
const ts = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const o in lt) {
      const n = t.getAttribute && t.getAttribute(o);
      if (n) {
        lt[o].fire({
          template: n
        });
        return;
      }
    }
};
class os {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, o) {
    const n = this._getHandlersByEventName(t);
    n.includes(o) || n.push(o);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, o) {
    const n = (...r) => {
      this.removeListener(t, n), o.apply(this, r);
    };
    this.on(t, n);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...o) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (n) => {
        try {
          n.apply(this, o);
        } catch (r) {
          console.error(r);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, o) {
    const n = this._getHandlersByEventName(t), r = n.indexOf(o);
    r > -1 && n.splice(r, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
d.eventEmitter = new os();
const ns = (e, t) => {
  d.eventEmitter && d.eventEmitter.on(e, t);
}, rs = (e, t) => {
  d.eventEmitter && d.eventEmitter.once(e, t);
}, ss = (e, t) => {
  if (d.eventEmitter) {
    if (!e) {
      d.eventEmitter.reset();
      return;
    }
    t ? d.eventEmitter.removeListener(e, t) : d.eventEmitter.removeAllListeners(e);
  }
};
var is = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: qr,
  bindClickHandler: es,
  clickCancel: qn,
  clickConfirm: so,
  clickDeny: Wn,
  enableLoading: xe,
  fire: Gr,
  getActions: Ie,
  getCancelButton: Ae,
  getCloseButton: pt,
  getConfirmButton: ie,
  getContainer: W,
  getDenyButton: be,
  getFocusableElements: gt,
  getFooter: qt,
  getHtmlContainer: ht,
  getIcon: Ce,
  getIconContent: Xo,
  getImage: Wt,
  getInputLabel: Jo,
  getLoader: $e,
  getPopup: k,
  getProgressSteps: mt,
  getTimerLeft: Kr,
  getTimerProgressBar: Qe,
  getTitle: Vt,
  getValidationMessage: Je,
  increaseTimer: Jr,
  isDeprecatedParameter: To,
  isLoading: en,
  isTimerRunning: Qr,
  isUpdatableParameter: $o,
  isValidParameter: Ao,
  isVisible: Vn,
  mixin: Zr,
  off: ss,
  on: ns,
  once: rs,
  resumeTimer: Lo,
  showLoading: xe,
  stopTimer: Bo,
  toggleTimer: Xr
});
class as {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, o) {
    this.callback = t, this.remaining = o, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const o = this.running;
    return o && this.stop(), this.remaining += t, o && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const Io = ["swal-title", "swal-html", "swal-footer"], ls = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const o = t.content;
  return ps(o), Object.assign(cs(o), us(o), ds(o), ws(o), fs(o), hs(o), ms(o, Io));
}, cs = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((n) => {
    pe(n, ["name", "value"]);
    const r = (
      /** @type {keyof SweetAlertOptions} */
      n.getAttribute("name")
    ), i = n.getAttribute("value");
    !r || !i || (r in de && typeof de[
      /** @type {keyof typeof defaultParams} */
      r
    ] == "boolean" ? t[r] = i !== "false" : r in de && typeof de[
      /** @type {keyof typeof defaultParams} */
      r
    ] == "object" ? t[r] = JSON.parse(i) : t[r] = i);
  }), t;
}, us = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((n) => {
    const r = (
      /** @type {keyof SweetAlertOptions} */
      n.getAttribute("name")
    ), i = n.getAttribute("value");
    !r || !i || (t[r] = new Function(`return ${i}`)());
  }), t;
}, ds = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((n) => {
    pe(n, ["type", "color", "aria-label"]);
    const r = n.getAttribute("type");
    if (!(!r || !["confirm", "cancel", "deny"].includes(r))) {
      if (t[`${r}ButtonText`] = n.innerHTML, t[`show${dt(r)}Button`] = !0, n.hasAttribute("color")) {
        const i = n.getAttribute("color");
        i !== null && (t[`${r}ButtonColor`] = i);
      }
      if (n.hasAttribute("aria-label")) {
        const i = n.getAttribute("aria-label");
        i !== null && (t[`${r}ButtonAriaLabel`] = i);
      }
    }
  }), t;
}, ws = (e) => {
  const t = {}, o = e.querySelector("swal-image");
  return o && (pe(o, ["src", "width", "height", "alt"]), o.hasAttribute("src") && (t.imageUrl = o.getAttribute("src") || void 0), o.hasAttribute("width") && (t.imageWidth = o.getAttribute("width") || void 0), o.hasAttribute("height") && (t.imageHeight = o.getAttribute("height") || void 0), o.hasAttribute("alt") && (t.imageAlt = o.getAttribute("alt") || void 0)), t;
}, fs = (e) => {
  const t = {}, o = e.querySelector("swal-icon");
  return o && (pe(o, ["type", "color"]), o.hasAttribute("type") && (t.icon = o.getAttribute("type")), o.hasAttribute("color") && (t.iconColor = o.getAttribute("color")), t.iconHtml = o.innerHTML), t;
}, hs = (e) => {
  const t = {}, o = e.querySelector("swal-input");
  o && (pe(o, ["type", "label", "placeholder", "value"]), t.input = o.getAttribute("type") || "text", o.hasAttribute("label") && (t.inputLabel = o.getAttribute("label")), o.hasAttribute("placeholder") && (t.inputPlaceholder = o.getAttribute("placeholder")), o.hasAttribute("value") && (t.inputValue = o.getAttribute("value")));
  const n = Array.from(e.querySelectorAll("swal-input-option"));
  return n.length && (t.inputOptions = {}, n.forEach((r) => {
    pe(r, ["value"]);
    const i = r.getAttribute("value");
    if (!i)
      return;
    const l = r.innerHTML;
    t.inputOptions[i] = l;
  })), t;
}, ms = (e, t) => {
  const o = {};
  for (const n in t) {
    const r = t[n], i = e.querySelector(r);
    i && (pe(i, []), o[r.replace(/^swal-/, "")] = i.innerHTML.trim());
  }
  return o;
}, ps = (e) => {
  const t = Io.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((o) => {
    const n = o.tagName.toLowerCase();
    t.includes(n) || V(`Unrecognized element <${n}>`);
  });
}, pe = (e, t) => {
  Array.from(e.attributes).forEach((o) => {
    t.indexOf(o.name) === -1 && V([`Unrecognized attribute "${o.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, Do = 10, gs = (e) => {
  var t, o;
  const n = W(), r = k();
  if (!n || !r)
    return;
  typeof e.willOpen == "function" && e.willOpen(r), (t = d.eventEmitter) === null || t === void 0 || t.emit("willOpen", r);
  const l = window.getComputedStyle(document.body).overflowY;
  if (ys(n, r, e), setTimeout(() => {
    bs(n, r);
  }, Do), bt() && (vs(n, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, l), tr()), !et() && !d.previousActiveElement && (d.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const h = e.didOpen;
    setTimeout(() => h(r));
  }
  (o = d.eventEmitter) === null || o === void 0 || o.emit("didOpen", r);
}, Ze = (e) => {
  const t = k();
  if (!t || e.target !== t)
    return;
  const o = W();
  o && (t.removeEventListener("animationend", Ze), t.removeEventListener("transitionend", Ze), o.style.overflowY = "auto", ne(o, s["no-transition"]));
}, bs = (e, t) => {
  Kt(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", Ze), t.addEventListener("transitionend", Ze)) : e.style.overflowY = "auto";
}, vs = (e, t, o) => {
  or(), t && o !== "hidden" && cr(o), setTimeout(() => {
    e.scrollTop = 0;
  });
}, ys = (e, t, o) => {
  var n;
  (n = o.showClass) !== null && n !== void 0 && n.backdrop && x(e, o.showClass.backdrop), o.animation ? (t.style.setProperty("opacity", "0", "important"), R(t, "grid"), setTimeout(() => {
    var r;
    (r = o.showClass) !== null && r !== void 0 && r.popup && x(t, o.showClass.popup), t.style.removeProperty("opacity");
  }, Do)) : R(t, "grid"), x([document.documentElement, document.body], s.shown), o.heightAuto && o.backdrop && !o.toast && x([document.documentElement, document.body], s["height-auto"]);
};
var _t = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function Es(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = _t.email), e.input === "url" && (e.inputValidator = _t.url));
}
function xs(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (V('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function ks(e) {
  Es(e), e.showLoaderOnConfirm && !e.preConfirm && V(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), xs(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), fn(e);
}
let se;
var ze = /* @__PURE__ */ new WeakMap();
class I {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (Yo(
      this,
      ze,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    se = this;
    const o = Object.freeze(this.constructor.argsToParams(t));
    this.params = o, this.isAwaitingPromise = !1, Fo(ze, this, this._main(se.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, o = {}) {
    if (So(Object.assign({}, o, t)), d.currentInstance) {
      const i = Ee.swalPromiseResolve.get(d.currentInstance), {
        isAwaitingPromise: l
      } = d.currentInstance;
      d.currentInstance._destroy(), l || i({
        isDismissed: !0
      }), bt() && lo();
    }
    d.currentInstance = se;
    const n = As(t, o);
    ks(n), Object.freeze(n), d.timeout && (d.timeout.stop(), delete d.timeout), clearTimeout(d.restoreFocusTimeout);
    const r = $s(se);
    return ro(se, n), $.innerParams.set(se, n), Cs(se, r, n);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  then(t) {
    return Tt(ze, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return Tt(ze, this).finally(t);
  }
}
const Cs = (e, t, o) => new Promise((n, r) => {
  const i = (l) => {
    e.close({
      isDismissed: !0,
      dismiss: l,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  Ee.swalPromiseResolve.set(e, n), Ee.swalPromiseReject.set(e, r), t.confirmButton.onclick = () => {
    $r(e);
  }, t.denyButton.onclick = () => {
    Tr(e);
  }, t.cancelButton.onclick = () => {
    Sr(e, i);
  }, t.closeButton.onclick = () => {
    i(Te.close);
  }, zr(o, t, i), Gn(d, o, i), gr(e, o), gs(o), Ts(d, o, i), Ss(t, o), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), As = (e, t) => {
  const o = ls(e), n = Object.assign({}, de, t, o, e);
  return n.showClass = Object.assign({}, de.showClass, n.showClass), n.hideClass = Object.assign({}, de.hideClass, n.hideClass), n.animation === !1 && (n.showClass = {
    backdrop: "swal2-noanimation"
  }, n.hideClass = {}), n;
}, $s = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        k()
      ),
      container: (
        /** @type {HTMLElement} */
        W()
      ),
      actions: (
        /** @type {HTMLElement} */
        Ie()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        ie()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        be()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        Ae()
      ),
      loader: (
        /** @type {HTMLElement} */
        $e()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        pt()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        Je()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        mt()
      )
    }
  );
  return $.domCache.set(e, t), t;
}, Ts = (e, t, o) => {
  const n = Qe();
  U(n), t.timer && (e.timeout = new as(() => {
    o("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && n && (R(n), J(n, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && yt(
      /** @type {number} */
      t.timer
    );
  })));
}, Ss = (e, t) => {
  if (!t.toast) {
    if (!Xe(t.allowEnterKey)) {
      Ft("allowEnterKey"), Os();
      return;
    }
    Ps(e) || Ms(e, t) || at(-1, 1);
  }
}, Ps = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const o of t)
    if (o instanceof HTMLElement && Z(o))
      return o.focus(), !0;
  return !1;
}, Ms = (e, t) => t.focusDeny && Z(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && Z(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && Z(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, Os = () => {
  document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
};
I.prototype.disableButtons = yo;
I.prototype.enableButtons = vo;
I.prototype.getInput = po;
I.prototype.disableInput = xo;
I.prototype.enableInput = Eo;
I.prototype.hideLoading = qe;
I.prototype.disableLoading = qe;
I.prototype.showValidationMessage = ko;
I.prototype.resetValidationMessage = Co;
I.prototype.close = ue;
I.prototype.closePopup = ue;
I.prototype.closeModal = ue;
I.prototype.closeToast = ue;
I.prototype.rejectPromise = wo;
I.prototype.update = Po;
I.prototype._destroy = Mo;
Object.assign(I, is);
Object.keys(Rr).forEach((e) => {
  I[e] = function(...t) {
    if (se && se[e])
      return se[e](...t);
  };
});
I.DismissReason = Te;
I.version = "11.26.17";
const ke = I;
ke.default = ke;
typeof document < "u" && function(e, t) {
  var o = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(o), o.styleSheet) o.styleSheet.disabled || (o.styleSheet.cssText = t);
  else try {
    o.innerHTML = t;
  } catch {
    o.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-icon-animations: true;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem;container-name:swal2-popup}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}@container swal2-popup style(--swal2-icon-animations:true){.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const Us = async (e) => !Array.isArray(e) || e.length === 0 ? !0 : (await ke.fire({
  title: v("common.warning") || "重複的交易警告",
  text: `訂單 [${e.join(", ")}] 已經發起過交易。請先確認無其他交易進行中？`,
  icon: "warning",
  showCancelButton: !0,
  confirmButtonText: v("common.confirm") || "確定繼續",
  cancelButtonText: v("common.cancel") || "取消"
})).isConfirmed, Ys = (e) => new Date(e).toLocaleTimeString([], {
  hour: "2-digit",
  minute: "2-digit",
  hour12: !1
});
let Oe = !1;
const Fs = {
  /**
   * Call this once in your main app (e.g., main.ts)
   */
  init(e) {
    Oe = e === !0 || e === "true";
  },
  log: (...e) => {
    Oe && console.log(...e);
  },
  warn: (...e) => {
    Oe && console.warn(...e);
  },
  error: (...e) => {
    Oe && console.error("[DEBUG MODE]", ...e);
  },
  // Helper to check current state
  getStatus: () => Oe
}, Bs = (e) => {
  if (!/^\d{8}$/.test(e)) return !1;
  const t = [1, 2, 1, 2, 1, 2, 4, 1];
  let o = 0, n = 0;
  for (let r = 0; r < 8; r++) {
    const i = parseInt(e.charAt(r), 10) * t[r];
    if (i >= 10) {
      const l = Math.floor(i / 10), h = i % 10;
      r === 6 && l === 7 ? (o += 7, n += 8) : (o += l + h, n += l + h);
    } else
      o += i, n += i;
  }
  return o % 5 === 0 || n % 5 === 0;
}, Vs = (e) => {
  let t = e.replace(/\D/g, "");
  t.length > 8 && (t = t.slice(0, 8));
  let o = "", n = !1;
  return t.length === 8 ? Bs(t) ? n = !0 : o = "統編格式檢查錯誤，請確認號碼" : t.length > 0 && (o = `統編需為 8 位數字（目前已輸入 ${t.length} 碼）`), { value: t, error: o, isReady: n };
}, Ws = (e, t = "id-ID", o = "IDR") => {
  const n = typeof e == "string" ? parseFloat(e) : e;
  return Number.isNaN(n) ? "—" : new Intl.NumberFormat(t, {
    style: "currency",
    currency: o,
    minimumFractionDigits: o === "IDR" || o === "JPY" ? 0 : 2,
    maximumFractionDigits: 2
  }).format(n);
}, qs = async (e, t, o) => await ke.fire({
  title: o("order.checkoutConfirm"),
  html: `
      <div class="mb-4 text-left p-3 bg-blue-100 rounded-xl border border-blue-100 shadow-sm">
        <div class="text-[10px] text-blue-400 font-bold uppercase tracking-wider">${o("order.totalAmount")}</div>
        <div class="text-2xl font-black text-blue-700">$${t}</div>
      </div>

      <div class="text-left mb-4">
        <label class="block text-[10px] font-bold text-gray-700 uppercase mb-2 ml-1">
          ${o("order.selectMethod")}
        </label>
        <div class="relative bg-yellow-100 border border-yellow-700 inline-block">
          <select id="swal-status-select" 
            class="appearance-none cursor-pointer">
            ${e.map((n) => `<option value="${n.value}">${n.icon} ${n.label}</option>`).join("")}
          </select>
        </div>
      </div>

      <div class="text-left">
        <label class="block text-[10px] font-bold text-gray-700 uppercase mb-1 ml-1">${o("order.memo")}</label>
        <textarea id="swal-memo2" class="swal2-textarea placeholder="${o("order.memo")}"></textarea>
      </div>
    `,
  showCancelButton: !0,
  // --- Button Positioning ---
  reverseButtons: !0,
  // Cancel=Left, Confirm=Right
  confirmButtonText: o("common.confirm"),
  cancelButtonText: o("common.cancel"),
  // --- Visual Styling ---
  confirmButtonColor: "#1d4ed8",
  cancelButtonColor: "#878e9b",
  customClass: {
    actions: "flex flex-row justify-end w-full px-4",
    // Container styling
    confirmButton: "order-2 ml-3 rounded-xl px-10 py-3 font-bold",
    cancelButton: "order-1 text-gray-700 rounded-xl px-10 py-3"
  },
  preConfirm: () => {
    const n = document.getElementById("swal-status-select").value, r = document.getElementById("swal-memo2").value;
    return n ? { status: Number(n), memo2: r } : (ke.showValidationMessage(o("order.errorStatusRequired")), !1);
  }
});
export {
  Is as API_ENDPOINTS,
  oe as ORDER_ITEM_STATUS,
  Me as ORDER_STATUS,
  jo as ORDER_STATUS_LABELS,
  Ls as ROUTES,
  Ns as STATUS_FLOW,
  Us as confirmDuplicateOrders,
  Ws as formatCurrency,
  Ys as formatTime,
  Hs as formatToMerchantTime,
  _s as formatToMerchantTimeHM,
  zs as getItemStatusLabel,
  js as getOrderItemStatusLabel,
  Rs as getOrderStatusLabel,
  Fs as logger,
  Vs as processUbnInput,
  qs as promptStatusSelection,
  Ds as setI18n,
  v as t,
  Bs as validateUBN
};
